import React, { useState, useEffect } from 'react';
import { Link, useHistory, useLocation } from 'react-router-dom';
import { useDispatch, useSelector, connect } from 'react-redux';
import styles from '../../TransferPage.module.scss';
import blocation from 'assets/images/location-black.svg';
import bphone from 'assets/images/phone-black.svg';
import bbranch from 'assets/images/branch-black.svg';
import check from 'assets/images/check-icn.svg';
import { Button } from 'semantic-ui-react';
// import Pagging from '../pagging/Pagging';
import { Pagination } from 'semantic-ui-react';
import { beneficiaryActions, ratesActions } from '../../../../stores/_actions';
import { NoRecord } from '../../../common/norecord/norecord';

function Beneficiary(props) {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const sessionId = JSON.parse(localStorage.getItem('SessionId'));

  const payload = {
    Id: null,
    Message: null,
    CustomerCode: profile?.CustomerCode,
    Data: {
      CustomerCode: profile?.CustomerCode,
    },
    Status: false,
    SessionID: sessionId,
    IdType: null,
    FileType: null,
    Langcode: null,
  };

  const [setList, setListData] = useState();
  let customerListData;
  let status = false;
  useSelector((state) => {
    customerListData = state.beneficary.data;
    status = state.beneficary.beneficiaryList;
    setTimeout(() => {
      setListData((setList) => (setList = customerListData));
    }, 500);
  }, []);

  useEffect(() => {
    dispatch(beneficiaryActions.beneficiaryClient(payload));
    dispatch(ratesActions.clearRatesData());
    if (location.state?.items && location.state.items) {
      setButtonActive(false);
    } else {
      setButtonActive(true);
    }
  }, []);

  const selectBeneficiary = (items) => {
    const stateValue = {
      ...location.state,
      items,
      menu,
    };
    setButtonActive(false);
    history.push({ pathname: '/transfer', state: stateValue });
  };
  const [pager, setPage] = useState({
    page: 1,
    itemsPerPage: location.pathname == '/beneficiaries' ? 6 : 4,
  });
  const setPageNum = (event, { activePage }) => {
    setPage({ page: activePage });
  };
  const itemsPerPage = location.pathname == '/beneficiaries' ? 6 : 4;
  const { page } = pager;
  const totalPages = Math.ceil(customerListData && customerListData.length / itemsPerPage);
  const items = customerListData && customerListData.slice((page - 1) * itemsPerPage, (page - 1) * itemsPerPage + itemsPerPage);

  const activeBeneficary =
    items &&
    items.map((item, index) => (
      //const beneficiary = location.state.items != null ? (location.pathname == '/transfer' ? (item.AccountNo == location.state.items.AccountNo ? styles.active : '') : '') : '';
      <div className={styles.beneficiary__Bitem} key={index}>
        <h3>
          <span>{item.BenfName}</span>
          <span>{item.CustomerCode}</span>
        </h3>
        <p>
          <span>
            <img src={blocation} alt="" />
            {item.BenfCountry}
          </span>
          <span>
            {item?.BenfMobileNo && (
              <>
                <img src={bphone} alt="" /> + {`${item?.BenfMobileNo?.substring(0, 3)}${item?.BenfMobileNo?.substring(3)}`}
              </>
            )}
          </span>
        </p>
        <p className={styles.noBorder} style={{ minHeight: '94px' }}>
          <div>
            {item.Service === 'BANK TRANSFER' && (
              <>
                <span style={{ display: 'inline-block' }}>
                  <img src={bbranch} alt="" />
                </span>
                <span style={{ display: 'inline-block' }}>ACCOUNT NUMBER: {item.AccountNo}</span>
                {/* {`${item.BenfAddr1 ? ', ' : ''}`} {item.BenfAddr1} */}
              </>
            )}
            {item?.Service === 'BANK TRANSFER' && item?.BenfBank && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{item?.BenfBank}</span>
              </>
            )}
            {item?.Service === 'BANK TRANSFER' && item?.BenfBranch && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{item?.BenfBranch}</span>
              </>
            )}
            {item?.Service === 'BANK TRANSFER' && item?.BicCode && (
              <>
                <span style={{ fontSize: '12px', color: 'black', margin: '0 0 0 21px' }}>{item?.BicCode}</span>
              </>
            )}
          </div>
        </p>
        <h6>
          <span>
            Service Mode: <span>{item.Service}</span>
          </span>
          {location.pathname == '/transfer' || location.pathname == '/beneficiaries' ? (
            <span>
              <input
                type="radio"
                defaultChecked={location.state && item.AccountNo == location.state.items?.AccountNo}
                onClick={() => selectBeneficiary(item)}
                name="color"
              />
              <label>
                <span>
                  <img src={check} alt="" />
                </span>
              </label>
            </span>
          ) : (
            ''
          )}
        </h6>
      </div>
    ));

  const [menu, setMenu] = useState({
    beneficiary: false,
    amount: true,
    payment: false,
    confirm: false,
    transfer: false,
    print: false,
  });

  const backButton = () => {
    history.goBack();
  };
  const [buttonActive, setButtonActive] = useState(false);
  const forwordButton = () => {
    if (location.state.rateOfTransfer && location.state.rateOfTransfer.ratecharges) {
      setButtonActive(false);
    } else {
      setButtonActive(true);
    }
    setMenu((menu) => (menu, (menu.amount = true), (menu.beneficary = false)));
    const menuValue = {
      ...location.state,
      menu,
      buttonActive,
    };
    history.push({ pathname: '/transfer', state: menuValue });
  };

  return (
    <>
      <div className={styles.beneficiary}>
        <div className={styles.beneficiary__item}>{activeBeneficary ? activeBeneficary : <NoRecord status={status} />}</div>
      </div>

      {activeBeneficary ? (
        <div className={styles.pageCount}>
          <div className={styles.pageCountcont}>
            <span>{page}</span> / <span>{totalPages}</span>
          </div>
          <div className={styles.carousal}>
            <Pagination
              boundaryRange={0}
              defaultActivePage={page}
              ellipsisItem={null}
              firstItem={null}
              lastItem={null}
              siblingRange={null}
              totalPages={totalPages}
              onPageChange={setPageNum}
            />
          </div>
        </div>
      ) : (
        ''
      )}
      {location.pathname == '/transfer' ? (
        <div className={styles.pageLeft__buttonCenter}>
          {/* <Button  onClick={backButton}>previous</Button> */}
          <Button className={buttonActive ? 'disabled' : ''} onClick={forwordButton}>
            {' '}
            next{' '}
          </Button>
        </div>
      ) : (
        ''
      )}
    </>
  );
}

export { Beneficiary };
